import ToggleSwitch from "./desktop/ToggleSwitch";

export default ToggleSwitch;